import React from "react";
import styled from "styled-components";
import { Container } from "./container";
import BackgroundImage from "../images/texture-over-dark.png";
import BackgroundBorderBlueImage from "../images/Border-Blue-Bottom.png";
import BackgroundBorderWhiteImage from "../images/Border-White-Bottom.png";

const Wrapper = styled.div`
  margin: ${(props) => (props.title ? "-150px 0 0 0" : "-75px 0 0 0")};
`;

const ContentWrapper = styled.div`
  &::before,
  &::after {
    background: ${(props) =>
        props.colour === "primary"
          ? `url(${BackgroundBorderBlueImage})`
          : `url(${BackgroundBorderWhiteImage})`}
      0 0 repeat-x;
    content: "";
    display: inline-block;
    height: 16px;
    position: relative;
    top: -3px;
    width: 100%;
  }
  &::before {
    top: 8px;
    transform: rotate(180deg);
  }
`;

const Content = styled.div`
  background: ${(props) =>
    props.colour === "primary"
      ? `url(${BackgroundImage}) 0 0 repeat ` + props.theme.colours.primary
      : props.theme.colours.white};
  color: ${(props) =>
    props.colour === "primary"
      ? props.theme.colours.white
      : props.theme.colours.darkGrey};
  padding: 30px;
`;

const H1 = styled.h1`
  color: ${(props) => props.theme.colours.white};
  text-shadow: rgb(0, 0, 0) 0px 0px 10px;
`;

export const Card = (props) => {
  return (
    <Wrapper style={props.style} title={props.title}>
      <Container>
        {props.title && <H1>{props.title}</H1>}
        <ContentWrapper colour={props.colour}>
          <Content colour={props.colour}>{props.children}</Content>
        </ContentWrapper>
      </Container>
    </Wrapper>
  );
};
